<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('car_reservations')"
                        :isColumns="true"
                        @filter-div-status="datatable.filterStatus = $event">
                    <template v-slot:columns>
                        <div class="mb-1" v-for="(column,key) in datatable.columns">
                            <b-form-checkbox
                                :id="'checkbox-'+key"
                                :name="'checkbox-'+key"
                                :value="false"
                                :unchecked-value="true"
                                v-model="column.hidden"
                                v-if="column.field!='buttons'"
                            >
                                {{ column.label }}
                            </b-form-checkbox>
                        </div>
                    </template>
                </Header>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('car_reservations')"
                              :isColumns="true"
                              @filter-div-status="datatable.filterStatus = $event">
                    <div class="mb-1" v-for="(column,key) in datatable.columns">
                        <b-form-checkbox
                            :id="'checkbox-'+key"
                            :name="'checkbox-'+key"
                            :value="false"
                            :unchecked-value="true"
                            v-model="column.hidden"
                            v-if="column.field!='buttons'"
                        >
                            {{ column.label }}
                        </b-form-checkbox>
                    </div>
                </HeaderMobile>
            </template>

            <datatable-filter v-show="datatable.filterStatus"
                              @filter="filter"
                              @filterClear="filterClear"
            >
                <ValidationObserver ref="formModalValidate">
                    <b-row>
                       <b-col cols="12" md="6">
                            <b-form-group :label="$t('start_date')">
                                <select-date v-model="datatable.queryParams.start_date" :is-time="true"/>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" md="6">
                            <b-form-group :label="$t('end_date')">
                                <select-date v-model="datatable.queryParams.end_date" :is-time="true"/>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" md="6">
                            <b-form-group :label="$t('status')">
                                <parameter-selectbox v-model="datatable.queryParams.filter.status"
                                                    code="car_statuses"/>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </ValidationObserver>
            </datatable-filter>

            <datatable :isLoading.sync="datatable.isLoading"
                       :columns="datatable.columns"
                       :rows="datatable.rows"
                       :total="datatable.total"
                       :queryParams="datatable.queryParams"
                       :lineNumbers="false"
                       @on-page-change="onPageChange"
                       @on-sort-change="onSortChange"
                       @on-per-page-change="onPerPageChange"
                       v-show="datatable.showTable"
            />
            <CommonModal ref="approveReservationFormModal" size="md" :onHideOnlyX="true" @bHideModalHeaderClose="formClear">
                <template v-slot:CommonModalTitle>
                    {{ $t('approve_request') }}
                </template>
                <template v-slot:CommonModalContent>
                    <approve-reservation-form @approveReservationFormSuccess="approveReservationFormSuccess"
                                              :formId="formId"
                                 v-if="formProcess=='approve'"
                    />
                </template>
            </CommonModal>
            <CommonModal ref="deliverReservationFormModal" size="md" :onHideOnlyX="true" @bHideModalHeaderClose="formClear">
                <template v-slot:CommonModalTitle>
                    {{ $t('deliver_reservation') }}
                </template>
                <template v-slot:CommonModalContent>
                    <deliver-reservation-form @deliverReservationFormSuccess="deliverReservationFormSuccess"
                                              :formId="formId"
                                              :formData="formData"
                                 v-if="formProcess=='deliver'"
                    />
                </template>
            </CommonModal>
            <CommonModal ref="receiveReservationFormModal" size="md" :onHideOnlyX="true" @bHideModalHeaderClose="formClear">
                <template v-slot:CommonModalTitle>
                    {{ $t('receive_reservation') }}
                </template>
                <template v-slot:CommonModalContent>
                    <receive-reservation-form @receiveReservationFormSuccess="receiveReservationFormSuccess"
                                              :formId="formId"
                                 v-if="formProcess=='receive'"
                    />
                </template>
            </CommonModal>
            <CommonModal ref="detailFormModal" size="xl" :onHideOnlyX="true" @bHideModalHeaderClose="formClear">
                <template v-slot:CommonModalTitle>
                    {{ $t('detail').toUpper() }}
                </template>
                <template v-slot:CommonModalContent>
                    <detail-form :formId="formId" v-if="formProcess == 'detail'" />
                </template>
            </CommonModal>
        </app-layout>
    </div>
</template>
<script>
    //Template
    import AppLayout from '@/layouts/AppLayout';
    import Header from '@/layouts/AppLayout/Header'
    import HeaderMobile from '@/layouts/AppLayout/HeaderMobile'

    //Component
    import DatatableFilter from '@/components/datatable/DatatableFilter';
    import Datatable from '@/components/datatable/Datatable';
    import CommonModal from '@/components/elements/CommonModal';

    //Service
    import CarReservationService from '@/services/CarReservationService';

    //Other
    import qs from 'qs';
    import CarBrandSelectbox from "@/components/interactive-fields/CarBrandSelectbox.vue";
    import CarModelSelectbox from "@/components/interactive-fields/CarModelSelectbox.vue";
    import ApproveReservationForm from "@/modules/carReservation/pages/ApproveReservationForm.vue";
    import DeliverReservationForm from "@/modules/carReservation/pages/DeliverReservationForm.vue";
    import ReceiveReservationForm from "@/modules/carReservation/pages/ReceiveReservationForm.vue";
    import DetailForm from "@/modules/carReservation/pages/DetailForm.vue";

    export default {
        components: {
            DetailForm,
            CarModelSelectbox,
            CarBrandSelectbox,
            AppLayout,
            Header,
            HeaderMobile,

            DatatableFilter,
            Datatable,
            CommonModal,
            ApproveReservationForm,
            DeliverReservationForm,
            ReceiveReservationForm,
        },
        metaInfo() {
            return {
                title: this.$t('car_reservations')
            }
        },
        data() {
            return {
                formData: {},
                form: {},
                formId: null,
                formStatus: null,
                formProcess: null,
                datatable: {
                    isLoading: false,
                    columns: [
                        {
                            label: '',
                            field: 'buttons',
                            html: true,
                            hidden: false,
                            tdClass: 'p-0 text-center w-40 align-middle',
                            buttons: [
                                {
                                    text: this.$t('detail'),
                                    class: 'ri-search-eye-line',
                                    permission: 'campus_show',
                                    callback: (row) => {
                                        this.detailFormShow(row.id);
                                    },
                                },
                                {
                                    text: this.$t('approve_request'),
                                    class: 'ri-check-fill',
                                    permission: 'carreservation_approvereservation',
                                    callback: (row) => {
                                        this.approveReservationModalOpen(row.id);
                                    }
                                },
                                {
                                    text: this.$t('deliver_reservation'),
                                    class: 'ri-send-plane-line',
                                    permission: 'carreservation_deliverreservation',
                                    callback: (row) => {
                                        this.deliverReservationModalOpen(row.id, row);
                                    }
                                },
                                {
                                    text: this.$t('receive_reservation'),
                                    class: 'ri-inbox-archive-line',
                                    permission: 'carreservation_receivereservation',
                                    callback: (row) => {
                                        this.receiveReservationModalOpen(row.id);
                                    }
                                },
                            ]
                        },
                       {
                            label: this.toUpperCase('gear'),
                            field: this.getLocaleField('gear_name'),
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('plate'),
                            field: 'plate',
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('kilometer'),
                            field: 'kilometer',
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('maintenance_date'),
                            field: 'maintenance_date',
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('status'),
                            field: this.getLocaleField('status_name'),
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('type'),
                            field: this.getLocaleField('type_name'),
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('car_receiver'),
                            field: this.getLocaleField('receiver'),
                            hidden: false
                        },
                    ],
                    rows: [],
                    total: 0,
                    filterStatus: true,
                    showTable: false,
                    queryParams: {
                        start_date: null,
                        end_date: null,
                        filter: {},
                        sort: 'id',
                        page: 1,
                        limit: 20
                    }
                },
                start_date: null,
                end_date: null,
            };
        },
        methods: {
            async filter() {
                this.datatable.queryParams.page = 1;
                this.getRows();
            },
            filterClear() {
                this.datatable.queryParams.filter = {};
                this.datatable.queryParams.start_date = null;
                this.datatable.queryParams.end_date = null;
                this.getRows();
            },
            onPageChange(params) {
                this.datatable.queryParams.page = params.currentPage;
                this.getRows();
            },
            onPerPageChange(params) {
                this.datatable.queryParams.limit = params.currentPerPage;
                this.datatable.queryParams.page = 1;
                this.getRows();
            },
            onSortChange(params) {
                const sortType = params[0].type == 'desc' ? '-' : '';
                this.datatable.queryParams.sort = sortType + params[0].field;
                this.getRows();
            },
            getRows() {
                this.datatable.showTable = true;
                this.datatable.isLoading = true;

                const config = {
                    params: {
                        ...this.datatable.queryParams
                    },
                    paramsSerializer: (params) => qs.stringify(params, {encode: false})
                };

                return CarReservationService.getAll(config)
                                       .then((response) => {
                                           this.datatable.rows = response.data.data;
                                           this.datatable.total = response.data.pagination.total;
                                       })
                                       .finally(() => {
                                           this.datatable.isLoading = false;
                                       });
            },
            formClear() {
                this.formProcess = null
            },
            detailFormShow(id) {
                this.formId = id
                this.formProcess = 'detail'
                this.$refs.detailFormModal.$refs.commonModal.show()
            },
            approveReservationModalOpen(id) {
                this.formId = id
                this.formProcess = 'approve'
                this.$refs.approveReservationFormModal.$refs.commonModal.show()
            },
            approveReservationFormSuccess() {
                this.$refs.approveReservationFormModal.$refs.commonModal.hide()
                this.getRows()
                this.formClear()
            },
            deliverReservationModalOpen(id, data) {
                this.formId = id
                this.formData = data
                this.formProcess = 'deliver'
                this.$refs.deliverReservationFormModal.$refs.commonModal.show()
            },
            deliverReservationFormSuccess() {
                this.$refs.deliverReservationFormModal.$refs.commonModal.hide()
                this.getRows()
                this.formClear()
            },
            receiveReservationModalOpen(id) {
                this.formId = id
                this.formProcess = 'receive'
                this.$refs.receiveReservationFormModal.$refs.commonModal.show()
            },
            receiveReservationFormSuccess() {
                this.$refs.receiveReservationFormModal.$refs.commonModal.hide()
                this.getRows()
                this.formClear()
            },
        }
    }
</script>
